// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lucy-query-builder-query-editor-preview-body{border-top:1px solid #efefef}.qe-preview-pie-chart{display:flex;height:100%}.qe-preview-pie-chart .qe-preview-chart-props{padding:20px;background-color:#efefef}.qe-preview-pie-chart .qe-preview-chart-props label{margin:5px 0px}.qe-preview-pie-chart .qe-preview{width:100%;padding:20px}.qe-chart-select-option{padding:5px 10px}.qe-chart-select-option.disabled{opacity:.5}", ""]);
// Exports
module.exports = exports;
